import { KYMW0900Model } from "../kymw0900.model";
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { GetPreOrderFlagRequestModel } from '../vo/kymw0900-get-pre-order-flag-request.model';

/**
 * 予約商品フラグ取得サービス
 *
 * @export GetPreOrderFlagService
 * @class GetPreOrderFlagService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetPreOrderFlagService extends PlessJsonResponderSub<any> {

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetPreOrderFlagService
   */
  private successFunc: Function;

  model: KYMW0900Model;
  vo: GetPreOrderFlagRequestModel;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPreOrderFlagService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        PCodeCommon: {
          condition: {
            OrderCode: this.vo.orderCode,
            PCode: this.vo.pCode,
          }
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetPreOrderFlagService
   */
  execute(model: any, vo: GetPreOrderFlagRequestModel, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getPreOrderFlag', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPreOrderService
   */
  success(data: any): void {
    if (data !== null) {
      this.model.setPreOrderFlag(data);
      if (this.successFunc) {
        this.successFunc(data);
      }
    }
  }
}
